import { ProductRules } from '@agroone/business'
import { UserPermissions } from '@agroone/entities'
import { inject } from '@angular/core'
import { Route, Router } from '@angular/router'
import { environment } from '@front-app-environments/environment'
import { defaultRouteGuard } from './core/permissions/default-route.guard'
import { permissionsGuard } from './core/permissions/permissions.guard'

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./layout/layout').then((m) => m.Layout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [defaultRouteGuard],
        loadComponent: () => import('./features/forbidden/forbidden').then((m) => m.Forbidden),
      },
      {
        path: 'constants',
        title: 'Constants',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/constants/constants').then((m) => m.Constants),
      },
      {
        path: 'user-preferences',
        title: 'User Preferences',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.CROP_MODULE_ACCESS] },
        loadComponent: () => import('./features/user-preferences/user-preferences').then((m) => m.UserPreferences),
      },
      {
        path: 'campaigns',
        title: 'Campaigns',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/campaigns/campaigns').then((m) => m.Campaigns),
      },
      {
        path: 'laboratories',
        title: 'Laboratories',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/laboratories/laboratories').then((m) => m.Laboratories),
      },
      {
        path: 'alert-settings',
        title: 'Alert Settings',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/alert-settings/alert-settings').then((m) => m.AlertSettings),
      },
      {
        path: 'varieties',
        title: 'Varieties',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/varieties/varieties').then((m) => m.Varieties),
      },
      {
        path: 'homologa',
        title: 'Homologa',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_SPECIFICATION] },
        loadComponent: () => import('./features/homologa/homologa').then((m) => m.Homologa),
      },
      {
        path: 'control-compliance-v2/products',
        title: 'Products V2',
        canMatch: [() => ProductRules.isV2Available(environment.envName)],
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS] },
        loadComponent: () => import('./features/products-v2/products-v2').then((module) => module.ProductsV2),
      },
      {
        path: 'specifications',
        title: 'Specifications',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_SPECIFICATION] },
        loadComponent: () => import('./features/specifications/specifications').then((m) => m.Specifications),
      },
      {
        path: 'control-compliance-v2/specifications',
        title: 'Specifications',
        canMatch: [() => ProductRules.isV2Available(environment.envName)],
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS] },
        loadComponent: () => import('./features/specifications-v2/specifications-v2').then((m) => m.SpecificationsV2),
      },
      {
        path: 'ingredients',
        pathMatch: 'full',
        redirectTo: ({ queryParams, fragment }) =>
          inject(Router).createUrlTree(['/control-compliance-v2/ingredients'], {
            queryParams,
            fragment: fragment ?? undefined,
          }),
      },
      {
        path: 'control-compliance-v2/ingredients',
        title: 'Ingredients',
        canMatch: [() => ProductRules.isV2Available(environment.envName)],
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MODULE_ACCESS] },
        loadComponent: () => import('./features/ingredients/ingredients').then((m) => m.Ingredients),
      },
      {
        path: 'csr-settings',
        title: 'CSR Settings',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_CSR_EDITION] },
        loadComponent: () => import('./features/csr-settings/csr-settings').then((m) => m.CsrSettings),
      },
      {
        path: 'anomalies',
        title: 'Anomalies management',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_SPECIFICATION] },
        loadComponent: () => import('./features/anomalies/anomalies').then((m) => m.Anomalies),
      },
      {
        path: 'crop-types',
        title: 'Crop types',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/crop-types/crop-types').then((m) => m.CropTypes),
      },
      {
        path: 'countries',
        title: 'Countries',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/countries/countries').then((m) => m.Countries),
      },
      {
        path: 'nutrients',
        title: 'Nutrients',
        canActivate: [permissionsGuard],
        data: { permissions: [UserPermissions.MASTERDATA_MANAGER] },
        loadComponent: () => import('./features/nutrients/nutrients').then((m) => m.Nutrients),
      },
      {
        path: 'forbidden',
        title: 'Forbidden',
        loadComponent: () => import('./features/forbidden/forbidden').then((m) => m.Forbidden),
      },
      {
        path: '**',
        title: 'Page not found',
        loadComponent: () => import('./features/not-found/not-found').then((m) => m.NotFound),
      },
    ],
  },
]
